module.exports = __webpack_public_path__ + "media/images/flags/gf-325806d3f4024c3c4c87965059f654db.svg";